<template>
    <!-- 我的考试 -->
    <div class="my-test">
        <mytest-list-start></mytest-list-start>
    </div>
</template>

<script>
import mytestListStart from './components/mytest-list-start';
export default {
    components: {
        mytestListStart
    }
};
</script>

<style lang="less">
.my-test {
    .el-button--primary{
        background-color: #fff;
        color: #14b14e;
    }
    .test-card {
        td {
            height: 100px;
        }
    }
    .mytest-status {
        margin: 24px 0;
        span:nth-of-type(2) {
            margin-left: 18px;
        }
    }
    .test-time {
        > li {
            float: left;
            margin-right: 15px;
            font-size: 12px;
        }
    }
    .test-card {
        line-height: 40px;
        overflow: hidden;
        .test-status {
            font-size: 12px;
            margin-left: 20px;
            padding: 3px 10px;
            border-radius: 5px;
            background-color: pink;
            color: #fff;
        }
        .test-score {
            font-size: 36px;
            color: #44A8F3;
        }
        .button {
            float: right;
        }
    }
}
</style>

